import script from "./DataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=ts"

import "./DataTable.vue?vue&type=style&index=0&id=9fecb7d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fecb7d6"]])

export default __exports__